// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__l0-uW","title":"Price_title__2sjKe","blocks":"Price_blocks__f1nj4"};